import * as React from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import OverallSearch from "./OverallSearch";
import AdvancedSearch from "./AdvancedSearch";

import { useSelector } from "react-redux";

export default function BasicCard({ fieldsToSearch, dataSettings }) {
  const advancedSearchOn = useSelector((state) => state.advancedSearchOn);
  return (
    <Card>
      <CardContent>
        {advancedSearchOn ? (
          <AdvancedSearch
            fieldsToSearch={fieldsToSearch}
            dataSettings={dataSettings}
          ></AdvancedSearch>
        ) : (
          <OverallSearch></OverallSearch>
        )}
      </CardContent>
    </Card>
  );
}
